import { ReactElement } from 'react';
import { NavLink as RRDNavLink } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

import Text from 'components/_core/Text';

export const NavLink = styled(
  ({ disabled, ...props }): ReactElement =>
    disabled ? (
      <Box disabled={disabled} {...props} />
    ) : (
      <Box as={RRDNavLink} disabled={disabled} {...props} />
    ),
)`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  align-items: center;
  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Label = styled(Text).attrs({
  fontWeight: 'weight-500',
})`
  margin-left: ${({ theme }) => theme.spacings.abs16}px;
`;
